<template>
  <div class="flex relative justify-between items-center">
    <div class="flex items-center md:w-fit w-full md:justify-start justify-between">
      <div>
        <qooBtn type="mainBlack" text="Filters, Sort by" :classList="buttonStyle" :class="{ invisible: isFilterActive }" icon="filter.svg"
          @clickBtn="showFilter" :showText="!activeSearch" />
      </div>
      <div>
        <searchInput id="popupSearchModels" :placeholder="'Search by model'" @activateSearch="activateSearch" @search="popupSearchModels($event)"></searchInput>
      </div>
    </div>
    <div v-if="isFilterActive" :class="{ slideIn: isFilterActive, slideOut: !isFilterActive }"
      class="z-10 backdrop-blur-md filter-container absolute top-0 left-0 bg-stone-1000 hide-scrollbar hidden md:flex h-fit max-h-[70vh] overflow-hidden max-w-[384px] w-full flex-col mx-auto rounded-[30px]">
      <filterModal v-if="isShowFilter" @resetFilter="resetFilter" @updateFilter="updateFilter" :filterData="filterData"
        @close="showFilter" @handleSortType="$emit('handleSortType', $event)" :sortType="sortType" :sortStyle="sortStyle"
        @handleSortStyle="$emit('handleSortStyle', $event)"></filterModal>
    </div>
    <div v-if="isFilterActive" :class="{ slideIn: isFilterActive, slideOut: !isFilterActive }"
      class="md:hidden z-150 backdrop-blur-md filter-container fixed md:top-9 md:left-9 top-0 left-0 md:pt-0 pt-7 bg-stone-1000 hide-scrollbar flex h-[100vh] md:h-fit md:max-h-[70vh] overflow-hidden max-w-full md:max-w-[384px] w-full flex-col mx-auto md:rounded-[30px]">
      <filterModal v-if="isShowFilter" @updateFilter="updateFilter" :filterData="filterData" @close="showFilter"
        @handleSortType="$emit('handleSortType', $event)" @handleSortStyle="$emit('handleSortStyle', $event)">
      </filterModal>
    </div>
    <div class="md:flex items-center hidden" v-if="!props.hideToggle"></div>
  </div>
</template>

<script setup>
import searchInput from "./searchInput.vue";
import qooBtn from "@/components/base/common/qooBtn.vue";
import filterModal from "@/components/base/filter.vue";
import { jsonFilterData } from "@/util/filterData2";
import { ref, defineProps, defineEmits, computed, onMounted, watch } from "vue";
import useBreakpoint from "@/composable/useBreakpoint";
import { useFloorplan } from "@/store/floor.js";

let floorplan = {};
const staticFilter = false;

const {
  breakpoints,
  screens: { sm },
} = useBreakpoint();

const props = defineProps({
  side: {
    type: Boolean,
    default: false,
  },
  sortType: [String, Boolean],
  sortStyle: [String, Boolean],
  buttonStyle: {
    type: String,
    default: "",
  },
  firstTime: {
    type: Boolean,
    default: false,
  },
  hideToggle: {
    type: Boolean,
    default: false,
  },
  models: {
    type: Array,
  },
});

const filterData = ref(JSON.parse(JSON.stringify(jsonFilterData)));

const emit = defineEmits([
  "filterModels",
  "showFilter",
  "handleSortStyle",
  "handleSortType",
  "handleCheckboxChange",
]);

const floorsCount = ref([]);
const searchValue = ref("");

const isFilterActive = ref(false);
const showFilter = () => {
  isFilterActive.value = !isFilterActive.value;
};

const activeSearch = ref(true);
const activateSearch = (e) => {
  if (breakpoints.w < 768) activeSearch.value = e;
};

const popupSearchModels = (e) => {
  console.log('popupSearchModels', e);
  
  searchValue.value = e;
};


const filteredItems = computed(() => {
  let modelsArray = props.models;
  console.log('props.models 2', props.models);
  
  if (
    filterData.value.area.selected[0] && 
    (filterData.value.type.selected.length ||
    filterData.value.bathroom.selected.length ||
    filterData.value.area.selected[0] ||
    filterData.value.area.selected[1] ||
    floorsCount.value.length ||
    filterData.value.orientation?.selected?.length)
  ) {
    modelsArray = props.models.filter(
      (el) => {
        const res =
         (filterData.value?.bathroom.selected.length
          ? filterData.value?.bathroom.selected.includes(el.bathNumber)
          : true) 
          &&
          (filterData.value?.type.selected.length
            ? filterData.value?.type.selected.includes(el.specDescription)
            : true) 
            &&
          (filterData.value?.area.selected[0]
            ? +el.modelSize >= +filterData.value?.area.selected[0]
            : true) 
            &&
          (filterData.value?.area.selected[1]
            ? +el.modelSize <= +filterData.value?.area.selected[1]
            : true) 
            &&
          (filterData.value?.orientation?.selected?.length
            ? el.orientations.filter((exp) =>
              filterData.value.orientation?.selected.includes(exp),
            ).length
            : true) 
            &&
          el.floor_names?.length &&
          (floorsCount.value.length
            ? el.floor_names.filter((floor) => floorsCount.value.includes(+floor))
              .length
            : true)
        
        return res
      });
  } else {
    modelsArray = [];
  }

  console.log('modelsArray', modelsArray);

  if (searchValue.value !== "" && searchValue.value) {
    modelsArray = modelsArray.filter((item) => {
      return item.modelName
        .toUpperCase()
        .includes(searchValue.value.toUpperCase());
    });
  }

  return modelsArray;
});

watch(filteredItems, () => {
  setTimeout(() => {
    console.log('filterModels');
    emit("filterModels", filteredItems.value);
  }, 1000);
});
const updated = ref(false)

const updateFilter = (e) => { 
  updated.value = true;

  console.log('updateFilter', e);
  
  switch (e.name) {
    case "area":
      if (e.data[0] >= filterData.value.area.data[0] && e.data[1] <= filterData.value.area.data[1] && e.data[1] > e.data[0]) {
        filterData.value.area.selected = e.data;
      }
      break;

    case "type":
      if (Array.isArray(e.data)) {
        const validTypes = e.data.filter(item => filterData.value.type.data.includes(item));
        filterData.value.type.selected = validTypes;
      }
      break;

    case "bathroom":
      if (Array.isArray(e.data)) {
        const validBathrooms = e.data.filter(item => filterData.value.bathroom.data.includes(item));
        filterData.value.bathroom.selected = validBathrooms;
      }
      
      break;

    case "orientation":
      if (Array.isArray(e.data)) {
        const validOrientations = e.data.filter(item => filterData.value.orientation.data.includes(item));
        filterData.value.orientation.selected = validOrientations;
      }
      console.log('filterData.value.orientation', filterData.value.orientation);
      break;

    case "floor":
      if (e.data[0] >= filterData.value.floor.data[0] && e.data[1] <= filterData.value.floor.data[1] && e.data[1] > e.data[0]) {
        filterData.value.floor.selected = e.data;
      }
      break;
  }

  if (filterData.value.floor && (filterData.value.floor.selected[0] || filterData.value.floor.selected[1])) {
    floorsCount.value = [];
    for (let i = filterData.value.floor.selected[0]; i <= filterData.value.floor.selected[1]; i++) {
      floorsCount.value.push(i);
    }
  }
};

const isShowFilter = ref(false);

function extractParts(roomString) {
  const parts = roomString.split(" ");
  const number = parseInt(parts[0], 10);
  const hasDen = roomString.includes("+ Den");
  return { number, hasDen };
}

function compareRooms(a, b) {
  const roomA = extractParts(a);
  const roomB = extractParts(b);

  if (roomA.number !== roomB.number) {
    return roomA.number - roomB.number;
  }

  if (roomA.hasDen && !roomB.hasDen) {
    return 1;
  } else if (!roomA.hasDen && roomB.hasDen) {
    return -1;
  }

  return 0;
}
const addFilterData = async () => {
  if (floorplan.floorplanList && floorplan.floorplanList.length !== 0) {
    const models = floorplan.floorplanList;

    const types = [];
    const areas = [];
    const bathrooms = [];
    const myFloors = [];
    const orientation = []

    models.forEach((model) => {
      const { bathNumber, floor_names, specDescription, orientations } = model;
      
      if (!types.includes(specDescription)) {
        types.push(specDescription);
      }

      if (!bathrooms.includes(bathNumber)) {
        bathrooms.push(bathNumber);
      }

      if (!areas.includes(+model.modelSize)) {
        areas.push(+model.modelSize);
      }

      if (floor_names) {
        floor_names.forEach((f) => {
          if (!myFloors.includes(f)) {
            myFloors.push(f);
          }
        });
      }

      if (orientations?.length) {
        orientations.forEach((o) => {
          if (!orientation.includes(o)) {
            orientation.push(o);
          }
        });
      }
      
    });
    types.sort(compareRooms);
    filterData.value.type.data = types;
    filterData.value.orientation.data = orientation;

    // filterData.value.type.data = [...new Set(types)]
    filterData.value.area.data = [
      Math.min(...areas) - 10,
      Math.max(...areas) + 10,
    ];
    filterData.value.area.selected = filterData.value.area.data;
    filterData.value.bathroom.data = bathrooms;
    if (filterData.value.floor) {
      filterData.value.floor.data = [
        Math.min(...myFloors),
        Math.max(...myFloors),
      ];
      filterData.value.floor.selected = filterData.value.floor.data;
    } 
    console.log('filterData.value.floor', filterData.value.floor);
    
    if(Infinity == filterData.value.floor.data[0]) {
      filterData.value.floor.data = [1, 10]
      filterData.value.floor.selected = [1, 10]
    }
  }
};

const resetFilter = async () => {
  // console.log('--resetFilter--' );
  if (updated.value) {
    isShowFilter.value = false;
    filterData.value = JSON.parse(JSON.stringify(jsonFilterData));
    searchValue.value = "";
    floorsCount.value = [];
    floorplan = await useFloorplan();
    if (!staticFilter) addFilterData();
    emit('handleSortType', true)
    emit('handleSortStyle', false)
    isShowFilter.value = true;
    setTimeout(() => {
      updated.value = false
    }, 1100);
  }
};

onMounted(async () => {
  floorplan = await useFloorplan();
  addFilterData();
  isShowFilter.value = true;
});
</script>

<style lang="scss" scoped>
@keyframes slideIn {
  0% {
    width: 200px;
    height: 60px;
  }

  100% {
    width: 384px;
    height: 50vh;
  }
}

@keyframes slideOut {
  0% {
    width: 384px;
    height: 50vh;
    display: block;
  }

  100% {
    width: 200px;
    height: 60px;
    display: none;
  }
}

.slideOut {
  display: none;
}

.filter-container {
  animation-duration: 0.5s;
  animation-timing-function: ease-in-out;
}

.filter-container.slideIn {
  animation-name: slideIn;
}

.filter-container.slideOut {
  animation-name: slideOut;
}
</style>
